import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename", "label"];
import { useEffect } from 'react';
import { Input, useStore } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Password = props => {
  var {
      keyname = 'password',
      name,
      rename,
      label
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var nameBase = name || rename || keyname;
  var key = keyname || name;
  var {
    dispatch
  } = useStore();
  useEffect(() => dispatch({
    ["$" + key]: label
  }), [label]);
  return /*#__PURE__*/_jsx(Input, _extends({
    type: "password",
    placeholder: "Password",
    autoComplete: "on"
  }, elmProps, {
    name: nameBase,
    keyname: key
  }));
};
Password.displayName = 'Login.Password';